import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetLinkedAccountsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetLinkedAccountsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getLinkedAccounts = (request: GetLinkedAccountsRequest, options?: CashRequestOptions) =>
  post<GetLinkedAccountsRequest, GetLinkedAccountsResponse>('/2.0/cash/get-linked-accounts', request, {
    ...options,
    rejectOnError: true,
  })
